var _rect, _text, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxisSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Axis Select web",
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.982,
    height: 21
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1787",
    width: 126.982,
    height: 21,
    rx: 10.5,
    fill: "#97144d",
    opacity: 0.1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    "data-name": "Axis Bank Select",
    transform: "translate(23.982 16)",
    fill: "#97144d",
    fontSize: 14,
    fontFamily: "Lato-Italic, Lato",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Axis Bank Select"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "pre approved"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3031",
    d: "M11.359 3.22a1.035 1.035 0 011.281 0l.844.664a1.035 1.035 0 00.788.211l1.063-.153a1.035 1.035 0 011.109.64l.4 1a1.036 1.036 0 00.577.577l1 .4a1.035 1.035 0 01.64 1.109l-.158 1.058a1.035 1.035 0 00.211.788l.664.844a1.035 1.035 0 010 1.281l-.664.844a1.035 1.035 0 00-.211.788l.153 1.063a1.035 1.035 0 01-.64 1.109l-1 .4a1.036 1.036 0 00-.577.577l-.4 1a1.035 1.035 0 01-1.109.64l-1.063-.153a1.035 1.035 0 00-.788.211l-.844.664a1.035 1.035 0 01-1.281 0l-.844-.664a1.035 1.035 0 00-.783-.216l-1.063.153a1.035 1.035 0 01-1.109-.64l-.4-1a1.036 1.036 0 00-.577-.577l-1-.4a1.035 1.035 0 01-.64-1.109l.153-1.063a1.035 1.035 0 00-.211-.788l-.659-.839a1.035 1.035 0 010-1.281l.664-.844a1.035 1.035 0 00.212-.788l-.154-1.062a1.035 1.035 0 01.64-1.109l1-.4a1.035 1.035 0 00.577-.577l.4-1a1.035 1.035 0 011.109-.64l1.058.158a1.035 1.035 0 00.788-.211z",
    fill: "#97144d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3032",
    d: "M14.821 9.078l-3.516 4.073-1.982-1.628a.195.195 0 00-.247.3l2.136 1.748a.194.194 0 00.27-.023l3.633-4.214a.196.196 0 10-.3-.252z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }))));
}
export default SvgAxisSelect;